"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portfolioLoanRecordSchema = void 0;
var borrower_record_schema_1 = require("./borrower-record-schema");
var credit_check_record_schema_1 = require("./credit-check-record-schema");
var loan_validation_error_schema_1 = require("./loan-validation-error-schema");
exports.portfolioLoanRecordSchema = {
    type: 'object',
    required: [
        'applicationID',
        'portfolioID',
        'loanSequenceNumber',
        'canadaPostStandardProvinceSymbol',
        'currentFirstMortgageOutstandingAmountText',
        'currentLoanAmountText',
        'currentLoanInterestRateText',
        'currentPropertyAppraisedValueAmountText',
        'dwellingTypeCode',
        'energyEfficientIndicator',
        'firstMortgageCmhcAccountNumberText',
        'firstMortgageCmhcAccountStatusCode',
        'firstMortgageInsuranceLocationCode',
        'firstMortgageOutstandingAmountAtSecondMortgageText',
        'firstMortgageUnderwritingLenderCode',
        'interestAdjustmentDateText',
        'interestTypeCode',
        'lastStatusUpdateTimestamp',
        'lenderLoanNumber',
        'loanStatusCode',
        'loanTermExpiryDateText',
        'loanTermPeriod',
        'loanUnderwritingLenderCode',
        'lowRatioApplicationScorecardModelRatingCode',
        'lowRatioCmhcAccountNumberText',
        'lowRatioInsurableIndicator',
        'lowRatioLoanEverRuReviewedIndicator',
        'lowRatioOccupancyTypeCode',
        'lowRatioSelfEmployedSimplifiedIndicator',
        'lowRatioUnderwritingLenderCode',
        'multipleComponentText',
        'originalLendingValueAmountText',
        'originalLoanAmountText',
        'originalLoanToValueRatioText',
        'productTrackerID',
        'propertyAddressMunicipalityName',
        'propertyAddressPostalCode',
        'propertyAddressStreetDirectionID',
        'propertyAddressStreetName',
        'propertyAddressStreetNumber',
        'propertyAddressStreetTypeID',
        'propertyAddressUnitNumber',
        'propertyLocationLegalDescriptionText',
        'propertyRiskHitIndicator',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'remainingAmortizationPeriod',
        'tenureTypeCode',
        'totalUnitCount',
        'totalUnitCountText',
    ],
    properties: {
        applicationID: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        portfolioID: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        loanSequenceNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        canadaPostStandardProvinceSymbol: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        currentFirstMortgageOutstandingAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        currentFirstMortgageOutstandingAmountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
            default: '',
        },
        currentLoanAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        currentLoanAmountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters',
            default: '',
        },
        currentLoanInterestRate: {
            type: ['number', 'null'],
            maximum: 99,
            minimum: -99,
            decimal: [6, 4],
            errorMessage: 'should be a decimal with up to 6 digits in total and 4 digits of precision or null',
        },
        currentLoanInterestRateText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
            default: '',
        },
        currentPropertyAppraisedValueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        currentPropertyAppraisedValueAmountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
            default: '',
        },
        dwellingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
            default: '',
        },
        energyEfficientIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        firstMortgageCmhcAccountNumber: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        firstMortgageCmhcAccountNumberText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
            default: '',
        },
        firstMortgageCmhcAccountStatusCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        firstMortgageCmhcLoanToValueRatio: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [5, 2],
            errorMessage: 'should be a decimal with up to 5 digits in total and 2 digits of precision or null',
        },
        firstMortgageCmhcOutstandingAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        firstMortgageCmhcPremiumPaidAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        firstMortgageInsuranceLocationCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        firstMortgageOutstandingAmountAtSecondMortgage: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        firstMortgageOutstandingAmountAtSecondMortgageText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
            default: '',
        },
        firstMortgageUnderwritingLenderCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        interestAdjustmentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        interestAdjustmentDateText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
            default: '',
        },
        interestTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        lastStatusUpdateTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        lenderLoanNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
            default: '',
        },
        loanReviewTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        loanStatusCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        loanTermExpiryDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        loanTermExpiryDateText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
            default: '',
        },
        loanTermPeriod: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
            default: '',
        },
        loanUnderwritingLenderCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        lowRatioApplicationScorecardModelRatingCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        lowRatioCmhcAccountNumber: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        lowRatioCmhcAccountNumberText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
            default: '',
        },
        lowRatioFinalPriceEstimateAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        lowRatioFirstInsurableRiskingTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        lowRatioInsurableIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        lowRatioLatestRiskingTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        lowRatioLendingValueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        lowRatioLoanEverRuReviewedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        lowRatioNonInsurableRiskingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lowRatioOccupancyTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        lowRatioRiskingOutstandingBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        lowRatioSelfEmployedSimplifiedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        lowRatioUnderwritingLenderCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        multipleComponentText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should have variable length up to 50 characters',
            default: '',
        },
        originalAmortization: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
            default: '',
        },
        originalLendingValueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        originalLendingValueAmountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters',
            default: '',
        },
        originalLoanAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        originalLoanAmountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters',
            default: '',
        },
        originalLoanToValueRatio: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [5, 2],
            errorMessage: 'should be a decimal with up to 5 digits in total and 2 digits of precision or null',
        },
        originalLoanToValueRatioText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        productTrackerID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        propertyAddressMunicipalityName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
            default: '',
        },
        propertyAddressPostalCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        propertyAddressStreetDirectionID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        propertyAddressStreetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
            default: '',
        },
        propertyAddressStreetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
            default: '',
        },
        propertyAddressStreetTypeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        propertyAddressUnitNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        propertyLocationLegalDescriptionText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have variable length up to 60 characters',
            default: '',
        },
        propertyRiskHitIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
            default: '',
        },
        remainingAmortizationPeriod: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
            default: '',
        },
        tenureTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        totalUnitCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
            default: 0,
        },
        totalUnitCountText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        updatedPortfolioID: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        validatedPropertyAddressMunicipalityName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        validatedPropertyAddressPostalCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressStreetDirectionID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedPropertyAddressStreetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        validatedPropertyAddressStreetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        validatedPropertyAddressStreetTypeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressUnitNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedProvinceID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        borrowers: {
            type: ['array', 'null'],
            items: borrower_record_schema_1.borrowerRecordSchema,
        },
        creditChecks: {
            type: ['array', 'null'],
            items: credit_check_record_schema_1.creditCheckRecordSchema,
        },
        errors: {
            type: ['array', 'null'],
            items: loan_validation_error_schema_1.loanValidationErrorSchema,
        },
    },
};
exports.default = exports.portfolioLoanRecordSchema;
